import React, { useState, useEffect } from 'react';
import SettingsContext from './SettingsContext';
import getCoreSettings from '../common/settings/services/settingService';
import authService from '../authentication/AuthorizeService';

const SettingsContextProvider = (props) => {
  const [settingsData, setData] = useState({});

  const getSettings = async () => {
    const status = await authService.isAuthenticated();
    if (status) {
      const settings = await getCoreSettings(true);
      setData(settings);
    }
  };
  useEffect(() => {
    getSettings();
  }, []);

  return <SettingsContext.Provider value={{ settingsData }} {...props} />;
};

export default SettingsContextProvider;
